var _ellipse, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcon2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 11.5231,
    cy: 12.5,
    rx: 11.5231,
    ry: 11.5231,
    fill: "#21A6E9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.6489 10.3898C16.0247 7.64343 13.6291 6.40698 11.5247 6.40698C11.5247 6.40698 11.5247 6.40698 11.5188 6.40698C9.42041 6.40698 7.01886 7.63748 6.39469 10.3838C5.69919 13.4511 7.57764 16.0489 9.27775 17.6836C9.90786 18.2899 10.7163 18.5931 11.5247 18.5931C12.3332 18.5931 13.1416 18.2899 13.7658 17.6836C15.4659 16.0489 17.3444 13.4571 16.6489 10.3898ZM11.5247 13.3679C10.4904 13.3679 9.65225 12.5298 9.65225 11.4954C9.65225 10.4611 10.4904 9.62293 11.5247 9.62293C12.5591 9.62293 13.3972 10.4611 13.3972 11.4954C13.3972 12.5298 12.5591 13.3679 11.5247 13.3679Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon2);
export default __webpack_public_path__ + "static/media/icon2.a770ccf3e847aa9b8cbeea29e8c0842b.svg";
export { ForwardRef as ReactComponent };